import { appConfig } from "../../config/appConfig";

export const MFA_SESSION_TTL_MS = 24 * 60 * 60 * 1000;

const getSessionKey = (uid) => `${appConfig.mfaStoragePrefix}:last_verified:${uid}`;

export const hasEnrolledMfaFactor = (user) => {
  try {
    const factors = user?.multiFactor?.enrolledFactors || [];
    return factors.length > 0;
  } catch (error) {
    return false;
  }
};

export const markMfaSessionVerified = (uid) => {
  if (!uid) return;
  localStorage.setItem(getSessionKey(uid), String(Date.now()));
};

export const clearMfaSessionVerified = (uid) => {
  if (!uid) return;
  localStorage.removeItem(getSessionKey(uid));
};

export const isMfaSessionValid = (uid) => {
  if (!uid) return false;
  const raw = localStorage.getItem(getSessionKey(uid));
  if (!raw) return false;

  const ts = Number(raw);
  if (Number.isNaN(ts)) return false;

  return (Date.now() - ts) < MFA_SESSION_TTL_MS;
};
